import { useEffect, useState } from "react";
import {
  CompanyManageSetProductCompany,
  ProductFilterProducts,
  CompanyManageGetProductCompany,
  CompanyManageMyCompany,
  ProductFilterBerand,
} from "../../Api/Services";
import { toast } from "react-toastify";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompanyProduct() {
  const [isLoading, setLoading] = useState(true);
  const [Product, setProduct] = useState([]);
  const [Company, setCompany] = useState([]);
  const [ConnectProduct, setConnectProduct] = useState([]);
  const [CompanyId, setCompanyId] = useState();
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [SearchName, setSearchName] = useState("");

  const start = async () => {
    setProduct([]);
    setCompany([]);
    setConnectProduct([]);
    setCompanyId();
    try {
      const CompanyManageMyCompanysData = await CompanyManageMyCompany();
      if (
        CompanyManageMyCompanysData.status &&
        CompanyManageMyCompanysData.status === 200
      ) {
        setCompany(CompanyManageMyCompanysData.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);
          const ProductFilterProductsData = await ProductFilterProducts({});
          if (
            ProductFilterProductsData.status &&
            ProductFilterProductsData.status === 200
          ) {
            setProduct(ProductFilterProductsData.data.data.data);

            var elemet = [];
            ProductFilterProductsData.data.data.data.forEach((element) => {
              let model = {
                ProductId: element.id,
                Code: "",
              };
              elemet.push(model);
            });
            setConnectProduct(elemet);
          }
        }
      }
      if (
        CompanyManageMyCompanysData.data.data.length > 0 &&
        elemet.length > 0
      ) {
        let id = CompanyManageMyCompanysData.data.data[0].companyId;
        setCompanyId(id);
        const CompanyManageGetProductCompanyData =
          await CompanyManageGetProductCompany(id);
        if (
          CompanyManageGetProductCompanyData.status &&
          CompanyManageGetProductCompanyData.status === 200
        ) {
          var elemets = [...elemet];
          elemets.forEach((element) => {
            element.Code = "";
          });

          CompanyManageGetProductCompanyData.data.data.forEach((element) => {
            elemets.find((e) => e.ProductId == element.productId).Code =
              element.code;
          });

          setConnectProduct(elemets);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);
  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const Add = async () => {
    setLoading(true);
    try {
      let model = {
        CompanyId: CompanyId,
        Product: ConnectProduct.filter((e) => e.Code != ""),
      };
      const CompanyManageSetProductCompanyData =
        await CompanyManageSetProductCompany(model);
      if (
        CompanyManageSetProductCompanyData.status &&
        CompanyManageSetProductCompanyData.status === 200
      ) {
        toast.success("ثبت اطلاعات  با موفقیت انجام شد");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const SetCompany = async (id) => {
    setCompanyId(id);
    setLoading(true);
    try {
      const CompanyManageGetProductCompanyData =
        await CompanyManageGetProductCompany(id);
      if (
        CompanyManageGetProductCompanyData.status &&
        CompanyManageGetProductCompanyData.status === 200
      ) {
        var elemets = [...ConnectProduct];
        elemets.forEach((element) => {
          element.Code = "";
        });

        CompanyManageGetProductCompanyData.data.data.forEach((element) => {
          elemets.find((e) => e.ProductId == element.productId).Code =
            element.code;
        });

        setConnectProduct(elemets);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSearch = (id, e) => {
    const newForm = [...ConnectProduct];
    newForm.find((e) => e.ProductId == id).Code = e.target.value;
    setConnectProduct(newForm);
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
          p.productBerandId,
          p.productTypeId,
          p.productSeriesId,
          p.symbol,
          p.productSeriesEndId,
          p.productRamId,
          p.productRomId,
          p.productNetworkId,
          p.productCountryId,
          p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {Company &&
                Company.map((item, key) => (
                  <button
                    onClick={() => {
                      SetCompany(item.companyId);
                    }}
                    className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                      CompanyId == item.companyId ? "bg-warning" : ""
                    }`}
                  >
                    {item.companyName}
                  </button>
                ))}
            </div>
            <div className="d-flex">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={SearchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                }}
              />
            </div>
            {CompanyId && (
              <div className="w-100">
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>

                {brands.map(
                  (b, key) =>
                    Product.filter((e) => e.productBerandId == b.id).length >
                      0 && (
                      <>
                        <div
                          key={b}
                          className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                          onClick={() => handleClick(b.id)}
                        >
                          <h5>{b.name}</h5>
                        </div>
                        {activeItem === b.id && (
                          <div className="d-flex justify-content-center align-items-center w-100 tableC">
                            <table
                              className="table tableMore"
                              style={{ lineHeight: "normal" }}
                            >
                              <thead className="sticky-header">
                                <tr className="trTable">
                                  <th>نام کالای</th>
                                  <th>رنگ</th>
                                  <th>کد کالا در شرکت</th>
                                </tr>
                              </thead>

                              {Product &&
                                groupProducts(Product).map((group, gIndex) => (
                                  <tbody key={gIndex}>
                                    {group
                                      .filter((itemPro) => {
                                        const productFilter =
                                          SearchName?.toUpperCase?.() || "";
                                        const Pro =
                                          (
                                            (itemPro.productTypeName != " " &&
                                              itemPro.productTypeName + " ") +
                                            (itemPro.productSeriesName != " " &&
                                              itemPro.productSeriesName) +
                                            itemPro.symbol +
                                            (itemPro.productSeriesEndName != " "
                                              ? itemPro.productSeriesEndName +
                                                " "
                                              : " ") +
                                            (itemPro.productRamName != " " &&
                                              itemPro.productRamName + "/") +
                                            (itemPro.productRomName != " " &&
                                              itemPro.productRomName + " ") +
                                            (itemPro.productNetworkName !=
                                              " " &&
                                              itemPro.productNetworkName +
                                                " ") +
                                            (itemPro.productCountryName !=
                                              " " &&
                                              itemPro.productCountryName +
                                                " ") +
                                            (itemPro.isInsurance && "بیمه")
                                          )?.toUpperCase?.() || "";
                                        return Pro.includes(productFilter);
                                      })
                                      .filter((e) => e.productBerandId == b.id)
                                      .map((itemPro, iIndex) => {
                                        return (
                                          <tr key={itemPro.id}>
                                            {iIndex === 0 && (
                                              <>
                                                <td rowSpan={group.length}>
                                                  {itemPro.productTypeName !=
                                                    " " &&
                                                    itemPro.productTypeName +
                                                      " "}
                                                  {itemPro.productSeriesName !=
                                                    " " &&
                                                    itemPro.productSeriesName}
                                                  {itemPro.symbol}
                                                  {itemPro.productSeriesEndName !=
                                                  " "
                                                    ? itemPro.productSeriesEndName +
                                                      " "
                                                    : " "}
                                                  {itemPro.productRamName !=
                                                    " " &&
                                                    itemPro.productRamName +
                                                      "/"}
                                                  {itemPro.productRomName !=
                                                    " " &&
                                                    itemPro.productRomName +
                                                      " "}
                                                  {itemPro.productNetworkName !=
                                                    " " &&
                                                    itemPro.productNetworkName +
                                                      " "}
                                                  {itemPro.productCountryName !=
                                                    " " &&
                                                    itemPro.productCountryName +
                                                      " "}
                                                  {itemPro.isInsurance &&
                                                    "بیمه"}
                                                </td>
                                              </>
                                            )}
                                            <td>
                                              {" "}
                                              {itemPro.productColorName}{" "}
                                            </td>
                                            <td>
                                              <input
                                                onChange={(e) => {
                                                  handleChangeSearch(
                                                    itemPro.id,
                                                    e,
                                                  );
                                                }}
                                                value={
                                                  ConnectProduct.find(
                                                    (e) =>
                                                      e.ProductId == itemPro.id,
                                                  )?.Code
                                                }
                                              />
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                ))}
                            </table>
                          </div>
                        )}
                      </>
                    ),
                )}
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyProduct;
